import React, { useContext } from 'react';

import AuthContext from './services/firebase/AuthContext';

import AdminAppRoutes from './app/routes/AdminAppRoutes';
import CustomerAppRoutes from './app/routes/CustomerAppRoutes';
import ErrorAppRoutes from './app/routes/ErrorAppRoutes';
import LimboAppRoutes from './app/routes/LimboAppRoutes';
import LoggingContext from './services/logging/LoggingContext';
import MemberAppRoutes from './app/routes/MemberAppRoutes';
import SignedOutRouter from './app/routes/SignedOutRouter';
import SunsetRoutes from './services/SunsetRoutes';

const AppRoutes = () => {
    const { currentUser } = useContext(AuthContext);
    const errata = useContext(LoggingContext);

    if (!currentUser) return <SignedOutRouter />;
    
    const { organizationId = '', roles = [] } = currentUser;
    
    if (!roles.includes('admin')) return <SunsetRoutes />;

    // referrers are assigned to org 0000 when they first sign up
    if (organizationId === '0000') return <LimboAppRoutes />;
    
    // coop members
    if (roles.includes('member')) return <MemberAppRoutes />;
    if (roles.includes('admin')) return <AdminAppRoutes />;
    
    if (roles.includes('customer')) return <CustomerAppRoutes />;
    
    // if we made it this far there's a problem 
    
    errata.log({component: 'AppRoutes.3e81ae0977b3', user: currentUser, error: {
        message: 'User record is invalid or corrupt',
        stack: { roles, organizationId }
    }});
    
    return <ErrorAppRoutes title="Sorry - there's a problem with your account" message="Our tech team have been notified and we will be in touch shortly with a solution" />

}

export default AppRoutes;